module.exports = __webpack_public_path__ + "img/distributionEnergy.0cbaa70f.png";